import extend from "../../services/extend";
import http from "../../services/http";

/**
 * @ngdoc directive
 * @name ng.directive:vDrop
 * @param vue
 */

export default (vue) => extend(vue, (vue) => {
    return {
        name: 'modules.display.' + vue.exp,
        touchHandler: ('ontouchstart' in document.documentElement ? "touchstart" : "click"),
        init() {

            vue.set(this.name, false);

            // Set element data-roll="name"
            vue.el.dataset.roll = vue.exp;

            // Handle desktop mouseover
            if ( this.touchHandler === 'click' && vue.el.dataset.hasOwnProperty('hover')) {
                vue.el.addEventListener('mouseenter', () => {
                    vue.set('modules.hover', true);
                    if ( vue.el.dataset.hasOwnProperty('json')) {
                        this.enter(() => {
                            http.get(vue.el.dataset.json).then((r) => {
                                for (const [key, value] of Object.entries(r.payload)) {
                                    vue.set('service.' + key, value);
                                }
                                Object.keys(vue.get('modules.display')).forEach((index) => {
                                    vue.set('modules.display.' + index, index === vue.exp);
                                });
                            })
                        });
                    } else {
                        this.enter(() => {
                            Object.keys(vue.get('modules.display')).forEach((index) => {
                                vue.set('modules.display.' + index, index === vue.exp);
                            });
                        });
                    }

                    vue.el.addEventListener('mouseleave', () => {
                        this.leave();
                    }, { ive: true });

                }, { ive: true });

            } else {
                vue.set('modules.hover', false);
            }


            /**
             * This will handle the click/touch events
             */

            vue.el.addEventListener(this.touchHandler, () => {
                this.enter(() => {
                    vue.set(this.name, !vue.get(this.name));
                    if ( vue.el.dataset.hasOwnProperty('blur')) {
                        if ( vue.get(this.name) ) {
                            document.body.addEventListener(this.touchHandler, blurHandler, { ive: true });
                        } else {
                            document.body.removeEventListener(this.touchHandler, blurHandler);
                        }
                    }
                });
            }, { ive: true });

            /**
             * This will handle the blur event
             */

            let blurHandler = (event) => {
                let hide = true;
                let node = event.target;
                while (node) {
                    if (typeof node.attributes !== "undefined" && node.getAttribute('data-roll') === vue.exp ) {
                        hide = false;
                        break;
                    }
                    if ( node.parentNode) {
                        node = node.parentNode;
                    } else {
                        break;
                    }
                }

                // We can hide if nothing has been found
                if (hide === true) {
                    document.body.removeEventListener(this.touchHandler, blurHandler);
                    Object.keys(vue.get('modules.display')).forEach((index) => {
                        vue.set('modules.display.' + index, false);
                    });
                    vue.set('modules.hover', false);
                }
            };
        },

        // Show on mouse over
        enter ( callback ) {
            clearTimeout(vue.get('modules.timeout'));
            vue.set('modules.timeout', setTimeout(() => {
                if ( typeof callback !== "undefined") {
                    callback();
                }
            }, 150, this ));
        },

        // Hide on mouse leave
        leave () {
            clearTimeout(vue.get('modules.timeout'));
            vue.set('modules.timeout', setTimeout(() => {
                Object.keys(vue.get('modules.display')).forEach((index) => {
                    vue.set('modules.display.' + index, false);
                });
            }, 150, this ));
        }
    }
});